export function hasCompleteCompany(company) {
  return (
    company &&
    company.name_rus &&
    company.name_eng &&
    company.country &&
    company.address &&
    company.mail_address &&
    company.website &&
    company.email &&
    company.phone
  );
}
